import React from 'react';
import i18n from 'i18n';

import {
  CustomInputComponentProps,
  CustomInputComponentState
} from './CustomInputComponentModel';
import styles from './customInputComponent.module.scss';
import cx from 'classnames/bind';

const classNames = cx.bind(styles);

class CustomInputInternalModel {
  input: string;
  error?: React.ReactNode;

  constructor() {
    this.input = '';
    this.error = undefined;
  }

  get state(): CustomInputComponentState {
    return {
      input: this.input,
      error: this.error
    };
  }

  onChanged(input: string, error?: React.ReactNode): CustomInputComponentState {
    this.input = input;
    this.error = error;
    return this.state;
  }
}

export class CustomInputComponent extends React.Component<
  CustomInputComponentProps,
  CustomInputComponentState
> {
  ref: any;
  stateModel: CustomInputInternalModel;

  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
    this.stateModel = new CustomInputInternalModel();
    this.state = this.stateModel.state;
  }

  changed = () => {
    this.setState(this.stateModel.onChanged(this.ref.current.value));
  };

  clear = () => {
    this.ref.current.value = '';
    this.setState(this.stateModel.onChanged(''));
  };

  send = () => {
    const result = this.props.model.onChange(this.ref.current.value);
    if (result) {
      this.ref.current.value = result.invalidValue;
      this.setState(
        this.stateModel.onChanged(result.invalidValue, result.error)
      );
    } else {
      this.clear();
    }
  };

  render() {
    const customButtonStyle = this.props.model.buttonDirection
      ? { flexDirection: this.props.model.buttonDirection }
      : undefined;

    const customInputContainerClass = classNames('customInputContainer', {
      error: !!this.state.error
    });

    return (
      <div className={customInputContainerClass}>
        <div className={styles.descriptionArea}>
          <div className={styles.leftDescription}>
            {this.props.model.leftDescription}
          </div>
          <div className={styles.rightDescription}>
            {this.props.model.rightDescription}
          </div>
        </div>
        <textarea
          ref={this.ref}
          onChange={this.changed}
          placeholder={this.props.model.inputPlaceholder}
          value={this.state.input}
        />
        {this.state.error}
        <div className={styles.buttonArea} style={customButtonStyle}>
          <div className={styles.addButton} onClick={this.send}>
            {i18n.t('limitation.buttons.addDomain')}
          </div>
          <div className={styles.cancelButton} onClick={this.clear}>
            {i18n.t('limitation.buttons.cancelAddDomain')}
          </div>
        </div>
      </div>
    );
  }
}
